import Hamburger from "./Hamburger";
import TextareaAutosize from "react-textarea-autosize";
import css from "./ListRow.module.css";
import { FaDeleteLeft } from "react-icons/fa6";
import IngredientRow from "./IngredientRow";
import * as uuid from "uuid";

function ListRow(props) {
  function row() {
    return (
      <TextareaAutosize
        id={uuid.v4()}
        className={css.textareaAutosize}
        placeholder={"Enter " + props.listName}
        defaultValue={props.item.item}
        onChange={(state) => {
          props.item.item = state.target.value;
        }}
      />
    );
  }

  return (
    <div className={css.rowCotainer}>
      <Hamburger setEnableDrag={props.setEnableDrag} />

      {props.ingredientRow ? (
        <IngredientRow
          item={props.item}
          measurementType={props.measurementType}
        />
      ) : (
        row()
      )}
      <FaDeleteLeft
        className={css.deleteIcon}
        onClick={() => props.remove(props.item.key)}
      />
    </div>
  );
}

export default ListRow;
